export default __webpack_public_path__ + "static/GameSEO-6ba0cd2c99eee96a194353003db7dd23.jpg";